import {
  PPE_ALERT_STATUS,
  PPE_ALERT_TYPE,
  PPE_PERSON_STATUS,
} from "utils/constants";

export const computePersonStatus = (alerts = []) => {
  if (!alerts || alerts.length === 0) return PPE_PERSON_STATUS.VERIFIED;

  const hasConfirmedGEL = alerts.some(
    (a) =>
      a.type === PPE_ALERT_TYPE.GELS_SANCTIONS &&
      a.status === PPE_ALERT_STATUS.CONFIRMED,
  );
  if (hasConfirmedGEL) return PPE_PERSON_STATUS.BLOCKED;

  const hasPending = alerts.some((a) => a.status === PPE_ALERT_STATUS.PENDING);
  if (hasPending) return PPE_PERSON_STATUS.ALERT;

  return PPE_PERSON_STATUS.VERIFIED;
};

export const isHouseholdBlocked = (persons = []) => {
  return persons.some((person) =>
    (person.alerts || []).some(
      (a) =>
        a.type === PPE_ALERT_TYPE.GELS_SANCTIONS &&
        a.status === PPE_ALERT_STATUS.CONFIRMED,
    ),
  );
};

export const getBlockingPersonName = (persons = []) => {
  for (const person of persons) {
    const hasConfirmedGEL = (person.alerts || []).some(
      (a) =>
        a.type === PPE_ALERT_TYPE.GELS_SANCTIONS &&
        a.status === PPE_ALERT_STATUS.CONFIRMED,
    );
    if (hasConfirmedGEL) return person.fullName;
  }
  return null;
};
